<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="21" height="21" rx="2.5" stroke="currentColor"/>
        <path d="M5 5L11 10L17 5" stroke="currentColor" stroke-linecap="round"/>
        <path d="M5 12L11 17L17 12" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGScrollDown',
};
</script>

<style scoped lang="scss">

</style>
